import React, { useEffect } from 'react'
import MenuAula from './MenuAula'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import VideoAula from './VideoAula'
import './styles.css'
import { useCursosStorage } from '../../storage/cursos'
import { useNavigate } from 'react-router-dom'

export default function Aula() {

    const { selectedCurso, selectedAula } = useCursosStorage(state => state).dados

    const navigate = useNavigate();

    useEffect(()=>{
        if(selectedAula.length === 0){
            navigate('/painel')
        }
    },[])
    return (
        <div>
            <Header />
            <div className='divAula'>

            <div className='manuAula'>

                <MenuAula />
            </div>
            <VideoAula />
            </div>
            <Footer />
        </div>
    )
}
